"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = ['Dr.', 'Egr. Sig.', 'Frau', 'Gent.ma Sig.ra', 'Herr', 'Madame', 'Mademoiselle', 'Miss', 'Monsieur', 'Mr.', 'Mrs.', 'Ms.', 'Professor', 'Señor', 'Señora'];
exports.default = _default;
//# sourceMappingURL=salutation.js.map